import _ from 'lodash';
import React, { useState } from 'react';
import { Label, Segment } from "../..";
import Modal from "../Modal";
import CollectionListModal from "./CollectionListModal";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A collection list form.
 */
var CollectionListForm = function CollectionListForm(props) {
  var _useState = useState({}),
    item = _useState[0],
    setItem = _useState[1];

  /**
   * Handle Cancel event.
   */
  var handleCancel = function handleCancel(event) {
    var propsItem = props.item;
    _.invoke(props, 'onCancel', event, propsItem);
    setItem(item);
  };

  /** Handle Save event. */
  var handleSave = function handleSave(event, confirmationsData) {
    if (confirmationsData === void 0) {
      confirmationsData = null;
    }
    _.invoke(props, 'onSave', event, item, confirmationsData);
    setItem(item);
  };

  /** Handle Change event. */
  var handleChange = function handleChange(event) {
    var _event$target = event.target,
      name = _event$target.name,
      value = _event$target.value,
      checked = _event$target.checked;
    setItem(function (prev) {
      return Object.assign({}, prev, _.set(_.cloneDeep(item), name, checked || value));
    });
  };

  /** Handle Item Change event. */
  var handleItemChange = function handleItemChange(newItem) {
    setItem(function (prev) {
      return _.merge(_.cloneDeep(prev), newItem);
    });
  };
  var hasErrors = function hasErrors() {
    var errors = props.errors;
    return !_.isNil(errors) && (Array.isArray(errors) && errors.length || _.isPlainObject(errors) && Object.keys(errors).length || _.isString(errors));
  };

  /** Render label error. */
  var renderError = function renderError() {
    var errors = props.errors,
      formError = props.formError;
    if (!hasErrors()) {
      return null;
    }
    var displayedError = !formError && 'Saisie du formulaire incorrecte' || _.isFunction(formError) && formError(errors) || formError;
    return /*#__PURE__*/_jsx(Segment, {
      as: Modal.Description,
      basic: true,
      style: {
        marginTop: 0,
        marginBottom: 0,
        paddingBottom: 0
      },
      children: /*#__PURE__*/_jsx(Label, {
        color: "red",
        ribbon: true,
        children: typeof displayedError === 'function' ? displayedError() : displayedError
      })
    });
  };
  renderError.handledProps = [];
  var render = function render() {
    var children = props.children,
      actions = props.actions,
      content = props.content,
      className = props.className,
      confirmOn = props.confirmOn,
      confirmProps = props.confirmProps,
      control = props.control,
      extra = props.extra,
      errors = props.errors,
      open = props.open,
      cancelButton = props.cancelButton,
      saveButton = props.saveButton,
      formTitle = props.formTitle,
      onError = props.onError,
      modal = props.modal,
      modalContentProps = props.modalContentProps;
    var rest = getRest(CollectionListForm, props);
    var primaryButton = Object.assign({
      content: 'Enregistrer',
      icon: 'check',
      positive: true
    }, saveButton);
    if (!(_.isNil(children) || _.isEmpty(children))) {
      return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
        actions: actions,
        className: className,
        confirmOn: confirmOn,
        confirmProps: confirmProps,
        open: open,
        onPrimaryClick: handleSave,
        onSecondaryClick: handleCancel,
        primaryButton: primaryButton,
        secondaryButton: cancelButton,
        modal: modal,
        modalContentProps: modalContentProps,
        children: [!_.isNil(formTitle) && /*#__PURE__*/_jsx(Modal.Header, {
          children: formTitle
        }), renderError(), children]
      }));
    }
    if (! /*#__PURE__*/React.isValidElement(content) && _.isPlainObject(content)) {
      return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
        actions: actions,
        className: className,
        confirmOn: confirmOn,
        confirmProps: confirmProps,
        open: open,
        onPrimaryClick: handleSave,
        onSecondaryClick: handleCancel,
        primaryButton: primaryButton,
        secondaryButton: cancelButton,
        modal: modal,
        modalContentProps: modalContentProps,
        children: [!_.isNil(formTitle) && /*#__PURE__*/_jsx(Modal.Header, {
          children: formTitle
        }), renderError(), Modal.Content.create(content)]
      }));
    }
    if (!_.isNil(control)) {
      return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
        actions: actions,
        className: className,
        confirmOn: confirmOn,
        confirmProps: confirmProps,
        open: open,
        onPrimaryClick: handleSave,
        onSecondaryClick: handleCancel,
        primaryButton: primaryButton,
        secondaryButton: cancelButton,
        modal: modal,
        children: [!_.isNil(formTitle) && /*#__PURE__*/_jsx(Modal.Header, {
          children: formTitle
        }, "header"), renderError(), /*#__PURE__*/_jsx(Segment, Object.assign({
          as: Modal.Content,
          style: !_.isNil(errors) ? {
            marginTop: 0
          } : {}
        }, modalContentProps, {
          children: /*#__PURE__*/React.createElement(control, Object.assign({
            onChange: handleChange,
            onItemChange: handleItemChange,
            onError: onError
          }, item, extra, {
            errors: errors
          }))
        }), "content")]
      }));
    }
    return /*#__PURE__*/_jsxs(CollectionListModal, Object.assign({}, rest, {
      actions: actions,
      className: className,
      confirmOn: confirmOn,
      confirmProps: confirmProps,
      open: open,
      onPrimaryClick: handleSave,
      onSecondaryClick: handleCancel,
      primaryButton: primaryButton,
      secondaryButton: cancelButton,
      modal: modal,
      children: [!_.isNil(formTitle) && /*#__PURE__*/_jsx(Modal.Header, {
        children: formTitle
      }), renderError(), /*#__PURE__*/_jsx(Segment, Object.assign({
        as: Modal.Content,
        basic: true,
        attached: "top",
        style: !_.isNil(errors) ? {
          marginTop: 0
        } : {},
        scrolling: false
      }, modalContentProps, {
        children: content
      }))]
    }));
  };
  render.handledProps = [];
  return render();
};

// class CollectionListFormm extends React.Component {
//   static getDerivedStateFromProps(props, state) {
//     return !_.isEqual(props.open, state.open)
//       ?
//       : null;
//   }
// }

/**
 * Default props.
 */
CollectionListForm.handledProps = ["cancelButton"];
CollectionListForm.defaultProps = {
  cancelButton: {
    content: 'Annuler',
    icon: 'cancel'
  }
};
export default CollectionListForm;